var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFavico(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "113.87574mm",
    height: "117.30597mm",
    viewBox: "0 0 113.87574 117.30597",
    id: "svg1",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -351.47214,
    y: -97.631157,
    width: 240.17264,
    height: 197.21494,
    id: "rect67-2-0-5"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(-37.84168,-158.8099)"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#604d4f",
      fillOpacity: 1,
      stroke: "#050a13",
      strokeWidth: 1.48337,
      strokeDasharray: "none"
    },
    id: "rect1-9-4-4",
    width: 112.39238,
    height: 115.82259,
    x: 38.583366,
    y: 159.55157
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect1-9-2-9-3",
    style: {
      fill: "#af8225",
      fillOpacity: 1,
      stroke: "#050a13",
      strokeWidth: 0.766643,
      strokeDasharray: "none"
    },
    d: "m 44.754392,165.63984 0.05267,97.77201 h 6.869887 c 0.324535,0 0.585498,0.27399 0.585498,0.61411 v 5.51455 l 92.754173,0.0262 0.0263,-103.90067 z m 22.282987,12.73783 h 55.729901 c 2.34514,0 0.37476,6.09965 1.65337,7.60751 1.55797,1.45266 8.06404,-0.56059 8.06507,1.73279 l 0.0263,58.81324 c 7.9e-4,2.16831 -6.50723,0.1974 -8.09138,1.66555 -1.35697,1.48426 0.62302,8.11448 -1.65336,8.11448 H 67.037403 c -2.2347,0 -0.699814,-7.1081 -1.770282,-8.32495 -1.248482,-1.25733 -8.270784,0.50405 -8.270784,-1.52232 v -58.746 c 0,-2.42491 6.943492,-0.50717 8.387718,-1.73279 1.137191,-1.22501 -0.780552,-7.60751 1.653348,-7.60751 z"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#bf8e28",
      fillOpacity: 1,
      stroke: "#050a13",
      strokeWidth: 0.70884,
      strokeDasharray: "none"
    },
    id: "rect2-1-2-8",
    width: 58.603413,
    height: 63.750538,
    x: 66.209824,
    y: 184.5197,
    ry: 15.107617
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(0.26463797,0,0,0.25192046,164.4487,222.08874)",
    id: "text67-4-7-6",
    style: {
      fontSize: 128,
      textAlign: "start",
      writingMode: "lr-tb",
      direction: "ltr",
      whiteSpace: "pre",
      shapeInside: "url(#rect67-2-0-5)",
      display: "inline",
      fill: "#000000",
      fillOpacity: 1,
      stroke: "#050a13"
    }
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -351.47266,
    y: 19.745141,
    id: "tspan2"
  }, /*#__PURE__*/React.createElement("tspan", {
    style: {
      fontFamily: "'DejaVu Math TeX Gyre'",
      InkscapeFontSpecification: "'DejaVu Math TeX Gyre'"
    },
    id: "tspan1"
  }, "bit")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavico);
export default __webpack_public_path__ + "static/media/favico.00aef987d548447af080780ae66f80b8.svg";
export { ForwardRef as ReactComponent };